"use strict";

module.exports = '5.1.2'; // Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/version.js
// module id = 216
// module chunks = 0